import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Brand\SettingsController::edit
* @see app/Http/Controllers/Brand/SettingsController.php:33
* @route '/brands/{brand}/settings'
*/
export const edit = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/brands/{brand}/settings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Brand\SettingsController::edit
* @see app/Http/Controllers/Brand/SettingsController.php:33
* @route '/brands/{brand}/settings'
*/
edit.url = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { brand: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { brand: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            brand: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        brand: typeof args.brand === 'object'
        ? args.brand.id
        : args.brand,
    }

    return edit.definition.url
            .replace('{brand}', parsedArgs.brand.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Brand\SettingsController::edit
* @see app/Http/Controllers/Brand/SettingsController.php:33
* @route '/brands/{brand}/settings'
*/
edit.get = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Brand\SettingsController::edit
* @see app/Http/Controllers/Brand/SettingsController.php:33
* @route '/brands/{brand}/settings'
*/
edit.head = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Brand\SettingsController::update
* @see app/Http/Controllers/Brand/SettingsController.php:53
* @route '/brands/{brand}/settings'
*/
export const update = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '/brands/{brand}/settings',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\Brand\SettingsController::update
* @see app/Http/Controllers/Brand/SettingsController.php:53
* @route '/brands/{brand}/settings'
*/
update.url = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { brand: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { brand: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            brand: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        brand: typeof args.brand === 'object'
        ? args.brand.id
        : args.brand,
    }

    return update.definition.url
            .replace('{brand}', parsedArgs.brand.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Brand\SettingsController::update
* @see app/Http/Controllers/Brand/SettingsController.php:53
* @route '/brands/{brand}/settings'
*/
update.put = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Brand\SettingsController::update
* @see app/Http/Controllers/Brand/SettingsController.php:53
* @route '/brands/{brand}/settings'
*/
update.patch = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

const settings = {
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
}

export default settings